import { AppRoutes } from "./routes/AppRoutes";
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

import "./index.css";
import { CssBaseline } from "@mui/material";
import { PickersPtBr } from "./components/PickersPtBr";
import { AuthProvider } from "./context/AuthContext";
import { BrandThemeProvider } from "./context/BrandThemeContext";
import { NotificationProvider } from "./context/NotificationContext";

export function App() {
  return (
    // O AuthProvider fica por fora do tema porque é dele que sai o cliente
    // selecionado, que define as cores da marca.
    <AuthProvider>
      <BrandThemeProvider>
        <CssBaseline />
        <PickersPtBr>
          <NotificationProvider>
            <AppRoutes />
          </NotificationProvider>
        </PickersPtBr>
      </BrandThemeProvider>
    </AuthProvider>
  );
}

export default App;
